<template>
<li class="change-languages">
  <div class="language-select" @click="showLanguages =! showLanguages">
    <span class="flag-icon" :class="flagclass"></span>
    <span>{{$t('language')}}:</span>
    <span class="language">{{currentLanguage}}</span>
  </div>
  <div class="wrapper1 show-inherit">
    <transition name="slide1">
      <ul v-if="showLanguages" class="selectbox show-block">
        <li v-if="!isLanguageActive('en')" @click="changeLanguage('en')">
          <span class="flag-icon" :class="getLanguageClassByCode('en')"></span>
          {{ getLanguageNameByCode('en') }}
        </li>
        <li v-if="!isLanguageActive('sr')" @click="changeLanguage('sr')">
          <span class="flag-icon" :class="getLanguageClassByCode('sr')"></span>
          {{ getLanguageNameByCode('sr') }}
        </li>
        <li v-if="!isLanguageActive('ba')" @click="changeLanguage('ba')">
          <span class="flag-icon" :class="getLanguageClassByCode('ba')"></span>
          {{ getLanguageNameByCode('ba') }}
        </li>
      </ul>
    </transition>
  </div>
</li>
</template>

<script>
import LanguageHelper from '@/mixins/LanguageHelper'

export default {
  mixins: [LanguageHelper],
  data () {
    return {
      flagclass: '',
      currentLanguage: '',
      showLanguages: false
    }
  },
  methods: {
    displayCurrentLanguage () {
      this.currentLanguage = this.getLanguageNameByCode(this.$i18n.locale)
      this.flagclass = this.getLanguageClassByCode(this.$i18n.locale)
    },
    changeLanguage (language) {
      this.$i18n.locale = language
      this.displayCurrentLanguage()
      this.showLanguages = !this.showLanguages
    },
    isLanguageActive (language) {
      return language === this.$i18n.locale
    }
  },
  created: function () {
    this.displayCurrentLanguage()
  }
}
</script>
